import { useEffect, useState } from "react";
import axios from "axios";

const useTiempoRecoleccionProvincia = (year, mes, token, idAdministrador, provinciaSeleccionada, ciudadSeleccionada) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      if (!token || !idAdministrador) return;
      
      setLoading(true);
      setError(null);
      
      try {

        
        const response = await axios.post(
          `https://seguimientoconductor-nodejs-pits.com/administrador_seginus/obtenerTiempoRecoleccionProvincia`,
          { 
            anio: year, 
            mes: mes, 
            id_administrador: idAdministrador,
            provincia: provinciaSeleccionada || null,
            ciudad: ciudadSeleccionada || null 
          },
          { headers: { Authorization: token } }
        );
        
        setData(response.data || []);
      } catch (error) {
        setError(error);
        setData([]);
      } finally {
        setLoading(false);
      }
    };
    
    fetchData();
  }, [year, mes, token, idAdministrador, provinciaSeleccionada, ciudadSeleccionada]);

  return { data, loading, error };
};

export default useTiempoRecoleccionProvincia;